var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',_vm._g(_vm._b({ref:"tree",attrs:{"render-content":_vm.renderContent}},'el-tree',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }